import { message as messageAD } from 'antd';
import PropTypes from 'prop-types';
import './Message.css';

function message(props) {
  // eslint-disable-next-line react/prop-types, no-unused-vars
  const { content, type, duration, ...restProps } = props;
  const [messageApi] = messageAD.useMessage();

  switch (type) {
    case 'success':
      messageApi.open({
        type: 'success',
        // eslint-disable-next-line object-shorthand
        content: content
      });
      break;
    case 'error':
      messageApi.open({
        type: 'error',
        // eslint-disable-next-line object-shorthand
        content: content
      });
      break;
    case 'warning':
      messageApi.open({
        type: 'warning',
        // eslint-disable-next-line object-shorthand
        content: content
      });
      break;
    default:
      messageAD.info(content);
  }
}

message.PropTypes = {
  content: PropTypes.string,
  type: PropTypes.string,
  duration: PropTypes.number
};

export default message;
